const SvgItAutomation1 = (props) => (
  <>
    <path fill={props.p20} d="M0 0v192l96-96L0 0z" />
    <circle cx={96} r={1} fill="#001d6c" />
    <circle cx={96} cy={16} r={1} fill="#001d6c" />
    <circle cx={112} cy={16} r={1} fill="#001d6c" />
    <circle cx={96} cy={32} r={1} fill="#001d6c" />
    <circle cx={112} cy={32} r={1} fill="#001d6c" />
    <circle cx={128} cy={32} r={1} fill="#001d6c" />
    <circle cx={96} cy={48} r={1} fill="#001d6c" />
    <circle cx={112} cy={48} r={1} fill="#001d6c" />
    <circle cx={128} cy={48} r={1} fill="#001d6c" />
    <circle cx={144} cy={48} r={1} fill="#001d6c" />
    <circle cx={96} cy={64} r={1} fill="#001d6c" />
    <circle cx={112} cy={64} r={1} fill="#001d6c" />
    <circle cx={128} cy={64} r={1} fill="#001d6c" />
    <circle cx={144} cy={64} r={1} fill="#001d6c" />
    <circle cx={160} cy={64} r={1} fill="#001d6c" />
    <circle cx={96} cy={80} r={1} fill="#001d6c" />
    <circle cx={112} cy={80} r={1} fill="#001d6c" />
    <circle cx={128} cy={80} r={1} fill="#001d6c" />
    <circle cx={144} cy={80} r={1} fill="#001d6c" />
    <circle cx={160} cy={80} r={1} fill="#001d6c" />
    <circle cx={176} cy={80} r={1} fill="#001d6c" />
    <circle cx={96} cy={96} r={1} fill="#001d6c" />
    <circle cx={112} cy={96} r={1} fill="#001d6c" />
    <circle cx={128} cy={96} r={1} fill="#001d6c" />
    <circle cx={144} cy={96} r={1} fill="#001d6c" />
    <circle cx={160} cy={96} r={1} fill="#001d6c" />
    <circle cx={176} cy={96} r={1} fill="#001d6c" />
    <circle cx={192} cy={96} r={1} fill="#001d6c" />
    <circle cx={96} cy={112} r={1} fill="#001d6c" />
    <circle cx={112} cy={112} r={1} fill="#001d6c" />
    <circle cx={128} cy={112} r={1} fill="#001d6c" />
    <circle cx={144} cy={112} r={1} fill="#001d6c" />
    <circle cx={160} cy={112} r={1} fill="#001d6c" />
    <circle cx={176} cy={112} r={1} fill="#001d6c" />
    <circle cx={96} cy={128} r={1} fill="#001d6c" />
    <circle cx={112} cy={128} r={1} fill="#001d6c" />
    <circle cx={128} cy={128} r={1} fill="#001d6c" />
    <circle cx={144} cy={128} r={1} fill="#001d6c" />
    <circle cx={160} cy={128} r={1} fill="#001d6c" />
    <circle cx={96} cy={144} r={1} fill="#001d6c" />
    <circle cx={112} cy={144} r={1} fill="#001d6c" />
    <circle cx={128} cy={144} r={1} fill="#001d6c" />
    <circle cx={144} cy={144} r={1} fill="#001d6c" />
    <circle cx={96} cy={160} r={1} fill="#001d6c" />
    <circle cx={112} cy={160} r={1} fill="#001d6c" />
    <circle cx={128} cy={160} r={1} fill="#001d6c" />
    <circle cx={96} cy={176} r={1} fill="#001d6c" />
    <circle cx={112} cy={176} r={1} fill="#001d6c" />
    <circle cx={96} cy={192} r={1} fill="#001d6c" />
  </>
);

export default SvgItAutomation1;
